/**
 * @fileoverview GET handler for the "/deliverability/email/:app_group_id/data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { deliverabilityEmailAppGroupIdData } from "./constants";
import type {
  GetDeliverabilityEmailAppGroupIdDataParams,
  GetDeliverabilityEmailAppGroupIdDataResult,
} from "./types";

export const getDeliverabilityEmailAppGroupIdData = reactQueryFetcherAdapter(
  deliverabilityEmailAppGroupIdData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      startTime,
      endTime,
      mailboxProviders,
      domains,
      ipPools,
      campaignIds,
      workflowIds,
    }: GetDeliverabilityEmailAppGroupIdDataParams
  ): Promise<GetDeliverabilityEmailAppGroupIdDataResult> => {
    return fetch(
      `/deliverability/email/${appGroupId}/data`,
      "GET",
      {
        start_time: startTime,
        end_time: endTime,
        mailbox_providers: mailboxProviders,
        domains,
        ip_pools: ipPools,
        campaign_ids: campaignIds,
        workflow_ids: workflowIds,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
